import React from 'react';
import '../styles/components/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Gyaniraj Offset</h3>
            <p>A Complete Printing Solution Since 2013</p>
            <p>India's fastest growing printing production house</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📍 Chhatarpur, M.P. 471001</p>
            <p>📞 9993143569</p>
            <p>📧 gyanirajoffset1@gmail.com</p>
            <p>🕒 10:00 AM - 9:00 PM</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Gyaniraj Offset. All rights reserved. | Proprietor: Deepak Chaurasiya</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
